React = require 'react/addons'
Sidebar = require './shared/sidebar'
Router = require 'react-router'
Reflux = require 'reflux'
{ RouteHandler, State, Link } = Router;
NavigationStore = require '../stores/navigation-store'


module.exports = React.createClass
  displayName: 'App'

  mixins: [State, Reflux.connect(NavigationStore)]

  render: ->
    classes = React.addons.classSet
      logo: true
      hide: @isActive 'age-gate'
      'hide-logo': NavigationStore.hideLogo
      'show-logo': not(NavigationStore.hideLogo)

    appClasses = React.addons.classSet
      app: true
      'dark-mode': NavigationStore.darkMode
      'disable-animations': NavigationStore.areAnimationsDisabled

    logoFormat = if Modernizr.svg then '.svg' else '.png'

    prefix = CDN_URL

    React.createElement("div", {"className": (appClasses)},
      React.createElement("h1", {"className": (classes)}, React.createElement(Link, {"to": 'home'}, React.createElement("img", {"className": 'logo-image', "alt": 'Santera', "src": ("#{prefix}/img/logo-small#{logoFormat}")}), React.createElement("img", {"className": 'dark-logo-image', "alt": 'Santera', "src": ("/img/logo-small-dark#{logoFormat}")}))),
      React.createElement(Sidebar, null),
      React.createElement("div", {"id": 'content-area', "className": 'content'},
        React.createElement(RouteHandler, null)
      )
    )



/** WEBPACK FOOTER **
 ** ./~/cjsx-loader!./src/scripts/components/app.cjsx
 **/